import type { SolanaConverter } from '../../type'
import convertUpdateCommissionToActions from './updateCommission'
import convertWithdrawToActions from './withdraw'

const convertToActions: SolanaConverter = (args) => {
  // withdraw の場合
  const withdrawResult = convertWithdrawToActions(args)
  if (withdrawResult !== undefined) {
    return withdrawResult
  }

  // updateCommission の場合
  const updateCommissionResult = convertUpdateCommissionToActions(args)
  if (updateCommissionResult !== undefined) {
    return updateCommissionResult
  }

  return undefined
}

export default convertToActions
